import { render, staticRenderFns } from "./ForumEvents.vue?vue&type=template&id=d92557c2&scoped=true"
import script from "./ForumEvents.vue?vue&type=script&lang=js"
export * from "./ForumEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d92557c2",
  null
  
)

export default component.exports